import {
  FooterSettings,
  ResolvedStoreSettings,
  StoreThemeResponse,
} from '../constants/apiResponses.types';

export const getStoreSettings = (storeTheme: StoreThemeResponse): ResolvedStoreSettings => {
  const { storeSettings, general, storeScreen } = storeTheme;

  return {
    storeTabName: storeSettings?.storeTabName ?? general.storeTabName,
    favicon: storeSettings?.favicon ?? general.favicon,
    loaderAnimation: storeSettings?.loaderAnimation ?? general.loaderAnimation,
    defaultPlayerImage: storeSettings?.defaultPlayerImage ?? storeScreen.defaultPlayerImage,
    footer: resolveFooter(storeSettings?.footer, general.footer),
    noOffersTitleText:
      storeSettings?.emptyState?.noOffersTitleText ?? storeScreen.noOffersTitleText,
    noOffersMessageText:
      storeSettings?.emptyState?.noOffersMessageText ?? storeScreen.noOffersMessageText,
    seo: storeSettings?.seo ?? storeScreen.seo,
    maintenanceModeRichText:
      storeSettings?.maintenanceModeRichText ?? general.maintenanceModeRichText,
  };
};

const resolveFooter = (
  override: Partial<FooterSettings> | undefined,
  legacy: FooterSettings
): FooterSettings => {
  if (!override) return legacy;
  return { ...legacy, ...override };
};
